var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "courses-list unstyled" },
    _vm._l(_vm.courses, function(courseData, index) {
      return _c(
        "li",
        { key: courseData.url, class: { "in-header": _vm.inHeader } },
        [
          _c(
            "a",
            {
              attrs: { href: courseData.url },
              on: {
                click: function($event) {
                  return _vm.sendSearchClickEvent(courseData, index)
                }
              }
            },
            [
              _vm.isStaffUser && !_vm.mobile && !_vm.inHeader
                ? _c("AdminMenu", {
                    attrs: {
                      items: _vm.getAdminMenuItems(courseData),
                      badges: _vm.getAdminMenuBadges(courseData)
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("img", { attrs: { src: courseData.image_url } }),
              _vm._v(" "),
              _c("strong", [_vm._v(_vm._s(courseData.name))])
            ],
            1
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }